import { routesPath } from './routes';

export type AuthFlow =
  | { type: 'standard' }
  | { type: 'invitation'; invitation: string; organization: string }
  | { type: 'sso'; organization: string };

export const resolveAuthFlow = (
  location: Pick<Location, 'pathname' | 'search'>
): AuthFlow => {
  const params = new URLSearchParams(location.search);
  const invitation = params.get('invitation');
  const organization = params.get('organization');

  if (invitation && organization) {
    return { type: 'invitation', invitation, organization };
  }
  if (location.pathname === routesPath.sso && organization) {
    return { type: 'sso', organization };
  }
  return { type: 'standard' };
};

export const buildAuthorizationParams = (
  flow: AuthFlow,
  connectionType: string
): Record<string, string> => {
  const params: Record<string, string> = {
    redirect_uri: window.location.origin,
  };

  switch (flow.type) {
    case 'standard':
      params.connection = connectionType;
      break;
    case 'sso':
      params.organization = flow.organization;
      break;
    case 'invitation':
      params.organization = flow.organization;
      params.invitation = flow.invitation;
      break;
  }

  return params;
};
